import { sendMailingReport } from '@/API/repositories/mailing-report';
import Icon from '@/common/components/Icon';
import { getCronDescription } from '@/common/functions/cronTransformer';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRequestsContext } from '@/common/hooks/requestHook';
import styled from 'styled-components';

const ColorDot = styled.div`
	height: 14px;
	width: 14px;
	background-color: ${(props) => props.color};
	border-radius: 100%;
	margin: 0 auto;
`;

const TextEllipsisContainer = styled.div`
	width: 300px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
`;

const MailingReportTableItem = ({ report, index, onEdit }) => {
	const { makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const handleEdit = () => {
		onEdit(report);
	};

	const handleSend = async () => {
		const response = await makeRequest(
			sendMailingReport.bind(null, {
				mailingReportType: report.type,
			}),
		);

		if (!response?.data) {
			return addMessage('Error while sending report', 'error');
		}

		addMessage('Report sent', 'success');
	};

	return (
		<tr>
			<td>{index + 1}</td>
			<td>{report.type}</td>
			<td>{report.subject}</td>
			<td>
				<TextEllipsisContainer>
					{report.recipients.map((r, i) => (
						<span key={r}>{r}, </span>
					))}
				</TextEllipsisContainer>
			</td>
			<td>{getCronDescription(report.cron_time)}</td>
			<td>
				{report.active ? <ColorDot color='green' /> : <ColorDot color='red' />}
			</td>
			<td>
				<Icon name='edit' onClick={handleEdit} />
				<Icon
					name='send'
					onClick={handleSend}
					style={{ marginLeft: '10px' }}
				/>
			</td>
		</tr>
	);
};

export default MailingReportTableItem;
